import { useMemo } from 'react';

const useLocalTable = ({ content, tableSettings }) => {
  const { page, size } = tableSettings;

  const slicedContent = useMemo(() => {
    if (!content || !content.length) {
      return [];
    }
    return content.slice((page - 1) * size, page * size);
  }, [content, page, size]);

  return { content: slicedContent, totalElements: content.length ?? 0 };
};

export default useLocalTable;
